module.exports = __webpack_public_path__ + "5d92238e761e89d034c5bb0661d94b18.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-winter-green.png
// module id = 2761
// module chunks = 0